import { render, staticRenderFns } from "./QuickConfig.vue?vue&type=template&id=41184055&scoped=true"
import script from "./QuickConfig.vue?vue&type=script&lang=js"
export * from "./QuickConfig.vue?vue&type=script&lang=js"
import style0 from "./QuickConfig.vue?vue&type=style&index=0&id=41184055&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41184055",
  null
  
)

export default component.exports